// This file is auto-generated by Velocious. Do not edit it manually — any changes
// will be overwritten the next time it is generated. Run `velocious generate:frontend-models` to regenerate.
import FrontendModelBase from "velocious/build/src/frontend-models/base.js"

/**
 * Frontend model resource config.
 * @typedef {import("velocious/build/src/frontend-models/base.js").FrontendModelResourceConfig} FrontendModelResourceConfig
 */
/**
 * Fallback attribute value type for generated fields without narrower metadata.
 * @typedef {import("velocious/build/src/frontend-models/base.js").FrontendModelAttributeValue} FrontendModelAttributeValue
 */

/**
 * BoardColumnAttributes type.
 * @typedef {object} BoardColumnAttributes
 * @property {string} boardId - Attribute value.
 * @property {string | null} color - Attribute value.
 * @property {Date} createdAt - Attribute value.
 * @property {string} id - Attribute value.
 * @property {string} name - Attribute value.
 * @property {number} position - Attribute value.
 * @property {Date} updatedAt - Attribute value.
 */
/**
 * Attributes accepted by BoardColumnCreateAttributes.
 * @typedef {object} BoardColumnCreateAttributes
 * @property {BoardColumnAttributes["boardId"] | null} [boardId] - Permitted boardId value.
 * @property {BoardColumnAttributes["color"] | null} [color] - Permitted color value.
 * @property {BoardColumnAttributes["name"] | null} [name] - Permitted name value.
 * @property {BoardColumnAttributes["position"] | null} [position] - Permitted position value.
 */
/**
 * Attributes accepted by BoardColumnUpdateAttributes.
 * @typedef {object} BoardColumnUpdateAttributes
 * @property {BoardColumnAttributes["boardId"] | null} [boardId] - Permitted boardId value.
 * @property {BoardColumnAttributes["color"] | null} [color] - Permitted color value.
 * @property {BoardColumnAttributes["name"] | null} [name] - Permitted name value.
 * @property {BoardColumnAttributes["position"] | null} [position] - Permitted position value.
 */
/**
 * Frontend model for BoardColumn.
 * @augments {FrontendModelBase<BoardColumnAttributes, BoardColumnCreateAttributes, BoardColumnUpdateAttributes, BoardColumnAttributes["id"], string>}
 */
class BoardColumn extends FrontendModelBase {
  /** @returns {FrontendModelResourceConfig} - Resource config. */
  static resourceConfig() {
    return {
      modelName: "BoardColumn",
      attributes: [
        "boardId",
        "color",
        "createdAt",
        "id",
        "name",
        "position",
        "updatedAt",
      ],
      collectionCommands: [
        "reorder",
      ],
    }
  }

  /** @returns {Record<string, {type: "belongsTo" | "hasOne" | "hasMany", autoload?: boolean}>} - Relationship definitions. */
  static relationshipDefinitions() {
    return {
      board: {type: "belongsTo"},
      taskBoards: {type: "hasMany"},
    }
  }

  /** @returns {Record<string, string>} - Relationship model class names. */
  static relationshipModelClasses() {
    return {
      board: "Board",
      taskBoards: "TaskBoard",
    }
  }

  /** @returns {BoardColumnAttributes["boardId"]} - Attribute value. */
  boardId() { return /** @type {BoardColumnAttributes["boardId"]} */ (this.readAttribute("boardId")) }

  /**
   * @param {BoardColumnAttributes["boardId"] | null} newValue - New attribute value.
   * @returns {BoardColumnAttributes["boardId"] | null} - Assigned value.
   */
  setBoardId(newValue) { return /** @type {BoardColumnAttributes["boardId"] | null} */ (this.setAttribute("boardId", newValue)) }

  /** @returns {BoardColumnAttributes["color"]} - Attribute value. */
  color() { return /** @type {BoardColumnAttributes["color"]} */ (this.readAttribute("color")) }

  /**
   * @param {BoardColumnAttributes["color"] | null} newValue - New attribute value.
   * @returns {BoardColumnAttributes["color"] | null} - Assigned value.
   */
  setColor(newValue) { return /** @type {BoardColumnAttributes["color"] | null} */ (this.setAttribute("color", newValue)) }

  /** @returns {BoardColumnAttributes["createdAt"]} - Attribute value. */
  createdAt() { return /** @type {BoardColumnAttributes["createdAt"]} */ (this.readAttribute("createdAt")) }

  /**
   * @param {Date | string} newValue - New attribute value.
   * @returns {Date | string} - Assigned value.
   */
  setCreatedAt(newValue) { return /** @type {Date | string} */ (this.setAttribute("createdAt", newValue)) }

  /** @returns {BoardColumnAttributes["id"]} - Attribute value. */
  id() { return /** @type {BoardColumnAttributes["id"]} */ (this.readAttribute("id")) }

  /**
   * @param {BoardColumnAttributes["id"] | null} newValue - New attribute value.
   * @returns {BoardColumnAttributes["id"] | null} - Assigned value.
   */
  setId(newValue) { return /** @type {BoardColumnAttributes["id"] | null} */ (this.setAttribute("id", newValue)) }

  /** @returns {BoardColumnAttributes["name"]} - Attribute value. */
  name() { return /** @type {BoardColumnAttributes["name"]} */ (this.readAttribute("name")) }

  /**
   * @param {BoardColumnAttributes["name"] | null} newValue - New attribute value.
   * @returns {BoardColumnAttributes["name"] | null} - Assigned value.
   */
  setName(newValue) { return /** @type {BoardColumnAttributes["name"] | null} */ (this.setAttribute("name", newValue)) }

  /** @returns {BoardColumnAttributes["position"]} - Attribute value. */
  position() { return /** @type {BoardColumnAttributes["position"]} */ (this.readAttribute("position")) }

  /**
   * @param {BoardColumnAttributes["position"] | null} newValue - New attribute value.
   * @returns {BoardColumnAttributes["position"] | null} - Assigned value.
   */
  setPosition(newValue) { return /** @type {BoardColumnAttributes["position"] | null} */ (this.setAttribute("position", newValue)) }

  /** @returns {BoardColumnAttributes["updatedAt"]} - Attribute value. */
  updatedAt() { return /** @type {BoardColumnAttributes["updatedAt"]} */ (this.readAttribute("updatedAt")) }

  /**
   * @param {Date | string} newValue - New attribute value.
   * @returns {Date | string} - Assigned value.
   */
  setUpdatedAt(newValue) { return /** @type {Date | string} */ (this.setAttribute("updatedAt", newValue)) }

  /**
   * Runs reorder.
   * @param {...FrontendModelAttributeValue} commandArguments - Custom command arguments.
   * @returns {Promise<{boardColumns: import("./board-column.js").default[]}>} - Command response.
   */
  static async reorder(...commandArguments) {
    return /** @type {{boardColumns: import("./board-column.js").default[]}} */ (await this.executeCustomCommand({
      commandName: "reorder",
      commandType: "reorder",
      payload: BoardColumn.normalizeCustomCommandPayloadArguments(commandArguments),
      resourcePath: this.resourcePath()
    }))
  }

  /**
   * Returns board relationship helper.
   * @returns {import("velocious/build/src/frontend-models/base.js").FrontendModelSingularRelationship<BoardColumn, import("./board.js").Board, import("./board.js").BoardCreateAttributes>} - Relationship helper.
   */
  boardRelationship() { return /** @type {import("velocious/build/src/frontend-models/base.js").FrontendModelSingularRelationship<BoardColumn, import("./board.js").Board, import("./board.js").BoardCreateAttributes>} */ (this.getRelationshipByName("board")) }

  /**
   * Returns board.
   * @returns {import("./board.js").Board | null} - Loaded related model.
   */
  board() { return this.boardRelationship().loaded() }

  /**
   * Builds board.
   * @param {import("./board.js").BoardCreateAttributes} [attributes] - Attributes for the new related model.
   * @returns {import("./board.js").Board} - Built related model.
   */
  buildBoard(attributes = {}) { return this.boardRelationship().build(attributes) }

  /**
   * Loads board.
   * @returns {Promise<import("./board.js").Board | null>} - Loaded related model.
   */
  async loadBoard() { return await this.boardRelationship().load() }

  /**
   * Returns or loads board.
   * @returns {Promise<import("./board.js").Board | null>} - Loaded related model.
   */
  async boardOrLoad() { return await this.boardRelationship().orLoad() }

  /**
   * Sets board.
   * @param {import("./board.js").Board | null} model - Related model.
   * @returns {void}
   */
  setBoard(model) { this.boardRelationship().setLoaded(model) }

  /**
   * Returns taskBoards relationship helper.
   * @returns {import("velocious/build/src/frontend-models/base.js").FrontendModelHasManyRelationship<BoardColumn, import("./task-board.js").TaskBoard, import("./task-board.js").TaskBoardCreateAttributes>} - Relationship helper.
   */
  taskBoardsRelationship() { return /** @type {import("velocious/build/src/frontend-models/base.js").FrontendModelHasManyRelationship<BoardColumn, import("./task-board.js").TaskBoard, import("./task-board.js").TaskBoardCreateAttributes>} */ (this.getRelationshipByName("taskBoards")) }

  /**
   * Returns taskBoards.
   * @returns {import("velocious/build/src/frontend-models/base.js").FrontendModelHasManyRelationship<BoardColumn, import("./task-board.js").TaskBoard, import("./task-board.js").TaskBoardCreateAttributes>} - Relationship helper.
   */
  taskBoards() { return this.taskBoardsRelationship() }

  /**
   * Returns loaded taskBoards.
   * @returns {Array<import("./task-board.js").TaskBoard>} - Loaded related models.
   */
  taskBoardsLoaded() { return this.taskBoardsRelationship().loaded() }

  /**
   * Loads taskBoards.
   * @returns {Promise<Array<import("./task-board.js").TaskBoard>>} - Loaded related models.
   */
  async loadTaskBoards() { return await this.taskBoardsRelationship().load() }

  /**
   * Registers a class-level destroy callback.
   * @overload
   * @param {(payload: {id: string}) => void} callback - Event callback.
   * @param {import("velocious/build/src/frontend-models/base.js").FrontendModelEventOptions} [options] - Destroy event options.
   * @returns {Promise<() => void>} - Unsubscribe callback.
   */
  /**
   * @template {import("velocious/build/src/frontend-models/base.js").FrontendModelClass} T
   * @overload
   * @this {T}
   * @param {(payload: {id: import("velocious/build/src/frontend-models/base.js").FrontendModelEventPrimaryKeyValueFor<InstanceType<T>>}) => void} callback - Event callback.
   * @param {import("velocious/build/src/frontend-models/base.js").FrontendModelEventOptions} [options] - Destroy event options.
   * @returns {Promise<() => void>} - Unsubscribe callback.
   */
  /**
   * Implements class-level destroy callback registration.
   * @param {(payload: {id: never}) => void} callback - Type-erased event callback.
   * @param {import("velocious/build/src/frontend-models/base.js").FrontendModelEventOptions} [options] - Destroy event options.
   * @returns {Promise<() => void>} - Unsubscribe callback.
   */
  static async onDestroy(callback, options = {}) {
    return await this._registerDestroyEventCallback(callback, options)
  }
}

FrontendModelBase.registerModel(BoardColumn)

export {BoardColumn}

export default BoardColumn
